<div class="waiting-list-page">
  <div class="waiting-list-panel">
    <header>
      <img src="./assets/img/logo.webp" class="logo" alt="NIMMSTA" />
    </header>

    <main class="waiting-list-message" aria-labelledby="waiting-list-title">
      <div class="waiting-list-icon" aria-hidden="true">
        <span class="material-icons">schedule</span>
      </div>
      <h1 id="waiting-list-title">{{ 'waiting-list.title' | translate }}</h1>
      <p class="waiting-list-description">
        {{ 'waiting-list.top-text' | translate }}
      </p>
      <p class="waiting-list-support">
        {{ 'waiting-list.support-text' | translate }}
        <a href="mailto:support@nimmsta.com">support&#64;nimmsta.com</a>.
      </p>
      @if (isImpersonating) {
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="endImpersonation()"
        >
          {{ 'end_impersonation' | translate }}
        </button>
      } @else {
        <button
          type="button"
          class="btn btn-outline-primary"
          (click)="logout()"
        >
          {{ 'waiting-list.sign-out' | translate }}
        </button>
      }
    </main>

    <footer class="waiting-list-footer">
      <a
        [href]="'imprint.url' | translate"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'imprint.label' | translate }}</a
      >
      <span aria-hidden="true">·</span>
      <a
        [href]="'privacy.url' | translate"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'privacy.label' | translate }}</a
      >
      <span aria-hidden="true">·</span>
      <a
        [href]="'terms.url' | translate"
        target="_blank"
        rel="noopener noreferrer"
        >{{ 'terms.label' | translate }}</a
      >
    </footer>
  </div>

  <div class="waiting-list-product">
    <app-product-placement></app-product-placement>
  </div>
</div>
